import React, { useEffect, useState } from "react"
import { Spinner } from "@trimbleinc/modus-react-bootstrap"
import PublishedTaskComponent from "./PublishedTaskComponent"
import QuadriRestApi from "../apis/quadriRestApi"
import { TaskTypeDefinitionsCache } from "../apis/TaskTypeDefinitionsCache"
import { TaskTypeSimple } from "../apis/quadriRestApi"
import { useAppContext } from "../contexts/AppContext"

const PublishedTaskList = () => {
  const { projectID, accessToken, projectLocation, API } = useAppContext()
  const [loading, setLoading] = useState(true)
  const [presentationTasks, setPresentationTasks] = useState<TaskTypeSimple[]>([])

  useEffect(() => {
    const fetchPresentationTasks = async () => {
      try {
        setLoading(true)
        const restApi = new QuadriRestApi()
        await restApi.initialize(accessToken, projectLocation)
        const tasks = await restApi.getTasks(projectID, ["PRESENT_AS_TRIMBIM_TOOL"])
        const sortedTasks = tasks.sort((a, b) => a.name.localeCompare(b.name))
        setPresentationTasks(sortedTasks)
      } catch (err) {
        console.error("Error fetching presentation tasks:", err)
      } finally {
        setLoading(false)
      }
    }
    const initializeTaskTypeDefinition = async () => {
      console.log("Initialised task type definitions")
      await TaskTypeDefinitionsCache.getInstance().init(accessToken, projectLocation)
    }

    if (projectLocation) {
      initializeTaskTypeDefinition()
      fetchPresentationTasks()
    }
  }, [projectID, accessToken, projectLocation])

  return (
    <>
      {loading ? (
        <div className="px-3">
          <div className="text-center">
            <Spinner animation="border" variant="primary" role="status" />
            <div className="h3 text-primary mt-3">Loading...</div>
          </div>
        </div>
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden"
            }}
          >
            {presentationTasks.length > 0 ? (
              <>
                {presentationTasks.map((item) => (
                  <PublishedTaskComponent key={item.taskId} taskTypeSimple={item} projectLocation={projectLocation} />
                ))}
              </>
            ) : (
              <div className="col-12 col-md-12 pl-0 pr-0">
                <div className="mt-5">
                  <div className="empty ">
                    <div className="empty-icon">
                      <i className="icon-font tc-icon-quadri i16"></i>
                    </div>
                    <div className="empty-text">
                      <h3 className="text-muted">No published presentations</h3>
                      <p className="small text-muted">
                        You can publish presentations from Object Manager and when they are shared to the Shared Object
                        Model they will show up here.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default PublishedTaskList
